import React, { useState } from "react";
import apiService from "../APIService";
import BackupIcon from "@mui/icons-material/Backup";
import CloseIcon from "@mui/icons-material/Close";

const UploadFile = (props) => {
  const [selected, setSelected] = useState("Choose File");
  const [sizeError, setSizeError] = useState("");
  const [fileName, setFileName] = useState("");
  const [apiError, setApiError] = useState("");
  const [path, setPath] = useState("");
  const [preview, setPreview] = useState("");
  const [size, setSize] = useState("");
  const [upload, setUpload] = useState(false);

  const data = props.item && props.item.data && JSON.parse(props.item.data);
  const type = data.extensions;
  const maxSize = data.max_size * 1024;
  let name;

  const handleChange = (e) => {
    const files1 = e.target.value.split("\\");
    name = files1[files1.length - 1];

    const file = e?.target?.files && e?.target?.files[0];
    if (file) {
      props?.inputValue?.current?.removeAttribute("disabled");
    } else {
      props?.inputValue?.current?.setAttribute("disabled", true);
    }

    if (file) {
      // Check file format
      const fileExtension = name.split(".").pop().toLowerCase();
      if (!type.some((el) => el.includes(fileExtension))) {
        setFileName(name);
        setApiError("*File extension should be jpeg, jpg, png");
        setPreview(URL?.createObjectURL(file));
        return;
      }

      // Check file size
      if (file.size > maxSize) {
        setFileName(name);
        setPreview(URL?.createObjectURL(file));
        setApiError("*File size should not be greater than 512 kb");
        return;
      }

      setApiError("");
      setUpload(true);
      setPath(file);
      setFileName(name);
      setSize(file.size);
      setPreview(URL?.createObjectURL(file));
      setSelected(name);
    }
  };

  const handleUpload = () => {
    apiService.uploadMedia(path).then((response) => {
      if (response?.data?.code === 200) {
        let data = { key1: response.data.key1 };
        props.handleClick(props.item.code, data);
        props.setTextOnClick(preview);
        setApiError("");
      } else {
        setApiError("Error uploading media");
        console.error("Error uploading media:", response);
      }
    });
  };

  const handleClose = () => {
    document.getElementById("customFile").value = "";
    setFileName("");
    setApiError("");
    setSizeError("");
    setSize("");
    setUpload(false);
    setPath("");
    setPreview("");
  };

  return (
    <div className="chat-text">
      <div className="custom-file action-tab">
        <input
          type="file"
          className="custom-file-input"
          id="customFile"
          accept=".jpeg, .jpg, .png"
          onChange={(e) => handleChange(e)}
        />

        <div className="upload-wrapper action-tab">
          {!fileName && <BackupIcon />}
          {!fileName && <p>Select file to upload</p>}
          {fileName && (
            <div className="filename-wrap">
              <img src={preview} alt="preview" style={{ width: 40 }} />
              <p
                style={{
                  color: "#1890ff",
                  fontSize: 12,
                  paddingLeft: 13,
                  width: "80%",
                  textAlign: "start",
                }}
              >
                {selected}
              </p>
              <CloseIcon
                style={{
                  cursor: "pointer",
                  fontSize: 13,
                  position: "relative",
                  top: "-1px",
                }}
                className="action-tab"
                onClick={() => handleClose()}
              />
            </div>
          )}
          {apiError && (
            <>
              <input
                type="file"
                className="custom-file-input"
                id="customFiles"
                accept=".jpeg, .jpg, .png"
                onChange={handleChange}
              />
              <div className="retry-btn">Retry</div>
            </>
          )}
          {upload && (
            <div
              className="form-group action-tab"
              style={{ marginTop: "20px" }}
            >
              <div className="btn-contr text-left">
                {/* <a
                   
                  href="#!"
                  style={{ fontSize: "15px" }}
                  onClick={() => {
                    handleUpload();
                  }}
                >
                 
                </a> */}
                <button className="upload-btn" onClick={handleUpload}>
                  {" "}
                  Upload
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
      <div
        style={{
          color: "red",
          textAlign: "start",
          position: "relative",
          top: "-17px",
          left: "10px",
        }}
      >
        {apiError && apiError} {sizeError && sizeError}
      </div>
    </div>
  );
};

export default UploadFile;
